<div class="row">
  <div class="col-6">
    <div class="card">
      <div class="card-footer">
        <div class=""> <i class="fas fa-chart-line"> </i><strong> Delay (24H) </strong></div>
      </div>
      <div id="delayGraph"></div>
      <div class="card-footer small-box-footer" style="text-align:center"><a href="#/device-graph/{{lineId}}">More info <i class="fas fa-arrow-circle-right"></i></a></div>
      <div class="overlay dark" *ngIf="loader" style="width: 100%; height: 280px; ">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
    </div>

  </div>
  <div class="col-6">
    <div class="card">
      <div class="card-footer">
        <div class=""> <i class="fas fa-chart-line"> </i><strong> Dropping (24H) </strong></div>
      </div>
      <div id="droppedGraph"></div>
      <div class="card-footer small-box-footer" style="text-align:center"><a href="#/device-graph/{{lineId}}">More info <i class="fas fa-arrow-circle-right"></i></a></div>
      <div class="overlay dark" *ngIf="loader" style="width: 100%; height: 280px">
        <i class="fas fa-2x fa-sync-alt fa-spin"></i>
      </div>
    </div>

  </div>
</div>

